import { isNil } from '@lucidlink/tscore';
import { NotImplementedError } from '#common/types';
import { bigIntToLong } from '#common/util';
import { LockType } from '#key-range-locking/types';
import { KeyRangeLockingRequestMsg, LockMsg, LockRange, ServiceBaseProto } from '#websocket/client/proto';
import { LockResponse } from './response';
import { KEY_RANGE_LOCKING_REQUEST_TYPE } from './types';
const DEFAULT_RETENTION_TIME_IN_SEC = 60n;
export class LockRequest {
    lockParams;
    destination;
    constructor(lockParams, destination) {
        this.lockParams = lockParams;
        this.destination = destination;
    }
    createMessage(requestId, version) {
        const lockingRequest = this.getKeyRangeLockingRequest();
        return ServiceBaseProto.RequestMsg.create({
            id: bigIntToLong(requestId),
            versionMajor: version.major,
            versionMinor: version.minor,
            versionBuild: version.build,
            [KEY_RANGE_LOCKING_REQUEST_TYPE]: lockingRequest,
        });
    }
    createResponse(responseMessage) {
        return new LockResponse(responseMessage);
    }
    getDestination() {
        return this.destination;
    }
    getKeyRangeLockingRequest() {
        const lockRanges = [];
        for (const lockRange of this.lockParams.lockRanges) {
            if (lockRange.lockType !== LockType.EXCLUSIVE) {
                throw new NotImplementedError('WebFS supports only Exclusive key range locking.');
            }
            lockRanges.push(this.getLockRangeParams(lockRange));
        }
        const lockMessage = LockMsg.create({
            lockRange: lockRanges,
        });
        const lockRequest = KeyRangeLockingRequestMsg.create({
            type: KeyRangeLockingRequestMsg.RequestType.LOCK,
            lock: lockMessage,
        });
        return lockRequest;
    }
    getLockRangeParams(lockRange) {
        return LockRange.create({
            lockOwner: lockRange.lockOwner,
            lockType: lockRange.lockType,
            startKey: lockRange.range.start,
            endKey: lockRange.range.limit,
            retentionTimeInSec: isNil(lockRange.retentionTimeInSec)
                ? bigIntToLong(DEFAULT_RETENTION_TIME_IN_SEC)
                : bigIntToLong(lockRange.retentionTimeInSec),
        });
    }
}
